export class RolloutApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public code?: number,
  ) {
    super(message);
    this.name = 'RolloutApiError';
  }
}

export type FormattedError = {
  message: string;
  httpStatus?: number;
  apiCode?: number;
};

function isRolloutApiError(error: unknown): error is RolloutApiError {
  // Duck-typing check - instanceof fails across module boundaries
  return (
    error instanceof Error &&
    error.name === 'RolloutApiError' &&
    'statusCode' in error
  );
}

export function formatApiError(error: unknown): FormattedError {
  if (isRolloutApiError(error)) {
    const prefix = error.statusCode ? `HTTP ${error.statusCode}: ` : '';
    const suffix = error.code ? ` (Code ${error.code})` : '';
    return {
      message: `${prefix}${error.message}${suffix}`,
      httpStatus: error.statusCode,
      apiCode: error.code,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: String(error) };
}
